import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatStr } from 'utils/formatStr';
import { formatPersianNumber } from 'utils/formatPersianNumber';
import { formatPersianDate } from 'utils/formatPersianDate';

const MessageSummary = ({ message, receiverName, phoneNumber, sentAt }) => {
  return (
    <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 space-y-4 md:space-y-5">
      <div className="flex items-start gap-3 md:gap-4">
        <div className="bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl p-2 md:p-3 flex-shrink-0">
          <Icon
            name="MessageSquare"
            size={20}
            color="#ffffff"
            className="md:w-6 md:h-6"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm md:text-base text-gray-500 mb-1 md:mb-2">
            متن پیام
          </h3>
          <p className="text-base md:text-lg lg:text-xl font-semibold text-gray-800 whitespace-pre-line">
            {formatStr(message, receiverName) || '---'}
          </p>
        </div>
      </div>

      <div className="flex items-start gap-3 md:gap-4">
        <div className="bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl p-2 md:p-3 flex-shrink-0">
          <Icon
            name="User"
            size={20}
            color="#ffffff"
            className="md:w-6 md:h-6"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm md:text-base text-gray-500 mb-1 md:mb-2">
            گیرنده پیام
          </h3>
          <p className="text-base md:text-lg lg:text-xl font-semibold text-gray-800">
            {receiverName || '---'}
          </p>
        </div>
      </div>

      <div className="flex items-start gap-3 md:gap-4">
        <div className="bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl p-2 md:p-3 flex-shrink-0">
          <Icon
            name="Phone"
            size={20}
            color="#ffffff"
            className="md:w-6 md:h-6"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm md:text-base text-gray-500 mb-1 md:mb-2">
            شماره تماس
          </h3>
          <p className="text-base md:text-lg lg:text-xl font-semibold text-gray-800">
            {formatPersianNumber(phoneNumber) || '---'}
          </p>
        </div>
      </div>

      <div className="flex items-start gap-3 md:gap-4">
        <div className="bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl p-2 md:p-3 flex-shrink-0">
          <Icon
            name="Clock"
            size={20}
            color="#ffffff"
            className="md:w-6 md:h-6"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm md:text-base text-gray-500 mb-1 md:mb-2">
            زمان ارسال
          </h3>
          <p className="text-base md:text-lg lg:text-xl font-semibold text-gray-800">
            {formatPersianDate(sentAt) || '---'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MessageSummary;
